import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AuthService} from '../auth.service';

@Component({
  selector: 'app-callback',
  template: '<p>Authentification en cours...</p>',
  standalone: false
})
export class CallbackComponent implements OnInit {

  constructor(private router: Router, private authService: AuthService) {}

  ngOnInit(): void {
    const params = new URLSearchParams(window.location.search);
    if (params.has('error')) {
      this.router.navigate(['/login'], {queryParams: {reason: 'cancelled'}});
      return;
    }
    if (this.authService.isAuthenticated()) {
      const targetUrl = this.authService.getPostLoginRedirectUrl();
      this.router.navigateByUrl(targetUrl || '/');
    } else {
      this.authService.login();
    }
  }
}
